import { render, staticRenderFns } from "./PersonDetailsCard.vue?vue&type=template&id=2ce2b8a6&scoped=true"
import script from "./PersonDetailsCard.vue?vue&type=script&lang=js"
export * from "./PersonDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./PersonDetailsCard.vue?vue&type=style&index=0&id=2ce2b8a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce2b8a6",
  null
  
)

export default component.exports